export default "__VITE_ASSET__4867a7fa__"